import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_FAILURE
} from '../constants'

export function* getCarLotsDataMasterSaga() {
  try {
      const queryString = '?per_page=-1&listing=true&combobox=true'
      const result =  yield call(BFFAgent.Datamasters.getCarLots, queryString)
      const carLotsList = result?.data?.data
  
      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_SUCCESS,
          data: { carLotsList }
      })

  }
    catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_CAR_LOTS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
